var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayPal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9234 12H32.9944C40.5571 12 43.3931 15.8 42.9568 21.4095C42.2296 30.6743 36.6303 35.7771 29.1766 35.7771H25.4317C24.4136 35.7771 23.7228 36.4648 23.4319 38.2743L21.8321 48.8781C21.723 49.5657 21.3594 49.9638 20.814 50H11.9787C11.1425 50 10.8516 49.3486 11.0698 48.0095L16.4509 14.0267C16.6691 12.6514 17.4326 12 18.9234 12Z",
    fill: "#009EE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39163 0H23.842C27.9015 0 32.7431 0.144381 35.946 2.88761C38.1061 4.72847 39.2234 7.65217 38.9627 10.8285C38.0689 21.5127 31.4768 27.5045 22.613 27.5045H15.5368C14.3077 27.5045 13.5256 28.2986 13.1904 30.3921L11.2166 42.6645C11.0676 43.4586 10.7324 43.9278 10.0993 44H1.16089C0.192569 44 -0.179863 43.2781 0.080839 41.6899L6.48667 2.34619C6.74737 0.757998 7.64121 0 9.39163 0Z",
    fill: "#113984"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 29L16.5 13.9629C16.7206 12.6309 17.4559 12 19 12H33.2279C35.5809 12 37.4926 12.3505 39 13.0165C37.5662 22.2701 31.3162 27.3876 23.0809 27.3876H16.0588C15.1397 27.3876 14.4412 27.8433 14 29Z",
    fill: "#172C70"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPal);
export default __webpack_public_path__ + "static/media/pay-pal.ba26589c23f06b009049e132de0fd411.svg";
export { ForwardRef as ReactComponent };